/**
 * @generated SignedSource<<f994f30dd97be3822eaade95df9378b5>>
 * @relayHash 08619cb4687448195662e27bf198a9e4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 596a9d67d6f570fde4886f4bd23bd6d470c0ddc8e71e1037b4bbbb7280f26b7f

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JourneyConfigurationPageQuery } from './JourneyConfigurationPageQuery.graphql';

import isValidationFGEnabled_provider from '@atlassian/jira-relay-provider/src/jira-journey-builder-improve-validation.relayprovider';

const node: PreloadableConcreteRequest<JourneyConfigurationPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "596a9d67d6f570fde4886f4bd23bd6d470c0ddc8e71e1037b4bbbb7280f26b7f",
    "metadata": {},
    "name": "JourneyConfigurationPageQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjirajourneybuilderimprovevalidationrelayprovider": isValidationFGEnabled_provider
    }
  }
};

export default node;
